(function (angular) {
  "use strict";

  angular.module("alk.services", []);

  angular
    .module("alk.services")
    .provider("Messages", function () {
      var broadcastType = "ngRoute";

      this.setBroadcastType = function (broadcast) {
        //  only supports ui.router or ngRoute for the moment
        broadcastType = broadcast;

        //  fall back to ngRoute if something weird is specified
        if (broadcastType !== "ngRoute" && broadcastType !== "ui.router")
          broadcastType = "ngRoute";
      };

      this.$get = ["$rootScope", "$timeout", "_", "$injector", function ($rootScope, $timeout, _, $injector) {
        var allMessages = [];
        var messagesToDisplay = [];
        var currentMessageId = 0;

        function handleRouteChange() {
          messagesToDisplay = [];

          for (var i = 0; i < allMessages.length; i++) {
            if (allMessages[i].showOnNextPage === true) {
              messagesToDisplay.push(allMessages[i]);
            }
          }

          // remove all the items from all messages that we are going to display on this page.
          allMessages = _.filter(allMessages, function (message) {
            return message.showOnNextPage !== true;
          });
        }

        if (broadcastType === "ui.router") {
          $injector.get("$transitions")
            .onSuccess({}, handleRouteChange);
        } else if (broadcastType === "ngRoute") {
          $rootScope.$on("$routeChangeSuccess", handleRouteChange);
        }

        return {
          add: function (type, message, options) {
            options = options || {};

            var onlyDisplayOne = options.onlyDisplayOne == null || options.onlyDisplayOne === true; // can use == with null because it means null or undefined
            var showOnNextPage = options.showOnNextPage == null || options.showOnNextPage === true;
            var deleteAfterTimeout = options.deleteAfterTimeout || false;
            var messageObj;

            if (showOnNextPage === true) {
              messageObj = _.find(allMessages, {
                message: message
              });
            } else {
              messageObj = _.find(messagesToDisplay, {
                message: message
              });
            }

            if (messageObj && onlyDisplayOne === true) {
              messageObj.number++;
            } else {
              messageObj = {
                type: type,
                message: message,
                number: 1,
                showOnNextPage: showOnNextPage,
                deleteAfterTimeout: deleteAfterTimeout,
                id: currentMessageId
              };

              if (_.isNumber(messageObj.deleteAfterTimeout)) {
                setTimeout(() => {
                  if (messageObj.showOnNextPage === true) {
                    allMessages = _.reject(allMessages, (m) => m.id === messageObj.currentMessageId);
                  } else {
                    messagesToDisplay = _.reject(messagesToDisplay, (m) => m.id === messageObj.currentMessageId);
                  }
                }, messageObj.deleteAfterTimeout);
              }

              currentMessageId++;

              if (messageObj.showOnNextPage === true) {
                allMessages.push(messageObj);
              } else {
                messagesToDisplay.push(messageObj);
              }
            }
          },
          getMessages: function () {
            return messagesToDisplay;
          },
          clear: function () {
            messagesToDisplay = [];
          }
        };
      }]
    });
})(window.angular);



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/Common/common-services.js